import React from "react";
import Card from "~/components-shared/Card/Card";
import { useSelector } from "react-redux";
import companySelectors from "~/store/company/selectors";
import { useDrop } from "react-dnd";
import { Badge, Icon, Picture, Text } from "~/components-shared";
import styled, { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
const Drop = styled.div`
  display: inline-block;
  margin-top: 50px;
`;
const StyledCard = styled(Card)`
  display: inline-flex;
  min-width: 180px;
  max-width: 200px;

  ${_ref => {
  let {
    $isOver,
    $canDrop,
    theme
  } = _ref;
  const isActive = $canDrop && $isOver;
  if (isActive) {
    return `background-color: ${theme.colors.success.secondary}`;
  }
  if ($canDrop) {
    return `background-color: ${theme.colors.warning.secondary}`;
  }
  return "";
}};
`;
const StyledText = styled(Text)`
  flex-grow: 1;
`;
const OrgChartCompanyCard = _ref2 => {
  let {
    memberCount
  } = _ref2;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const company = useSelector(companySelectors.getCompany);
  const [{
    canDrop,
    isOver
  }, drop] = useDrop({
    accept: "member",
    drop: () => ({
      id: undefined
    }),
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    })
  });
  if (!company) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Drop, {
    ref: drop
  }, /*#__PURE__*/React.createElement(StyledCard, {
    border: true,
    align: "center",
    minHeight: "18rem",
    $isOver: isOver,
    $canDrop: canDrop
  }, /*#__PURE__*/React.createElement(Picture, {
    border: "circled",
    src: company.logo,
    width: "4.5rem",
    height: "4.5rem",
    s: {
      mb: 4,
      mt: 6
    },
    name: company.name
  }), /*#__PURE__*/React.createElement(Text, {
    element: "span",
    weight: "semiBold",
    color: colors.primary.main
  }, t("OrgChartCompanyCard.company")), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 5,
    lineHeight: 7
  }, company.name), /*#__PURE__*/React.createElement(StyledText, {
    element: "span",
    color: "textSecondary",
    fontSize: 3
  }, t("OrgChartCompanyCard.employees"), ": ", company.employeeCount), /*#__PURE__*/React.createElement(Badge, {
    color: "grey"
  }, /*#__PURE__*/React.createElement(Text, {
    element: "span",
    color: "textSecondary",
    weight: "semiBold"
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "people",
    s: {
      mr: 1
    }
  }), memberCount))));
};
export default OrgChartCompanyCard;